require('./style.less');

var Marionette = require('marionette'),
    RedactionNoteModel = require('../../../notes/models/page/noteTypes/drawable/coordinate/redaction/redaction');

require('extendMoment');

module.exports = Marionette.ItemView.extend({

    tagName: 'li',
    className: 'pgInfoListItem',
    template: require('./pgInfoTemplate.hbs'),


    /**
     * Note: docId refers to the docId we are viewing; but the page can be of a dynamic folder in which case it will be a different doc id.
     * DVBC-1382: unsure how we want to show reason codes metrics
     * for now showing by page and in this dialog
     * make change in the future after feedback
     * may want to put in a subview for flexibility (once we decide how to display them)
     * If leave in here and a single page, may want to make modal height larger to avoid vertical overflow.
     * RedactionNoteModel.prototype.getReasonCodeString:
     * (function lives on redaction note model for code re-use)
     * should be organized better but waiting until we decide how this feature should be implemented
     * a helper fn or similar may be a better way to go
     *  TODO: now that descriptions are passed in with the codes in the shapes object -- could more easily include them in a report
     *  ... if so, would probably want to use HTML, not a string ... I guess could use a title attribute for hower at the least ...
     *  DVBC-1730 -- now reporting regular reason codes and full page reason codes separately
     */

    serializeData: function() {

        var pg = this.model,
            pgAttributes = pg.attributes,
            parentDynamicFolderDoc = pgAttributes.parentDynamicFolderDoc; //will be undefined for non dynamic folder pages


        var nonFullPageReasonCodesCxt = getTemplateCxtForReasonCodes('nonFullPage'),
            fullPageReasonCodesCxt = getTemplateCxtForReasonCodes('fullPage');


        return _.extend( {}, pgAttributes, {

            pageType: pg.getFriendlyName(),

            docId: parentDynamicFolderDoc
               ? parentDynamicFolderDoc.info.documentId
               : this.options.activeDocId,

            showOriginalImageInfo: pg.isFddImage(),
            showGOSInfo: pg.hasGosInfo(),
            showOverlayInfo: pg.isCold(), //show if cold, even though an overlay may not be applied, -- the overlay font info is really pertaining to the text (the overlay is prob an image)
            createdOn: pg.get('createdOn') ? moment.convertDBTimeToLocalTime( pg.get('createdOn') ) : '', // handle in case not passed by server

            hasNonFullPageReasonCodes: nonFullPageReasonCodesCxt.hasReasonCodes,
            nonFullPgReasonCodeStr: nonFullPageReasonCodesCxt.reasonCodeStr,

            hasFullPageReasonCodes: fullPageReasonCodesCxt.hasReasonCodes,
            fullPageReasonCodesStr: fullPageReasonCodesCxt.reasonCodeStr

        });


        function getTemplateCxtForReasonCodes(type) {

            var reasonCodesByCounts = pg.getReasonCodesCounts(type),
                hasReasonCodes = reasonCodesByCounts !== null,
                reasonCodeStr = hasReasonCodes
                    ? RedactionNoteModel.prototype.getReasonCodeString(reasonCodesByCounts)
                    : null;

            return {
                hasReasonCodes: hasReasonCodes,
                reasonCodeStr: reasonCodeStr
            };
        }


    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/dialogs/pageinfo/pageInfoDetail/pgInfoDetail.js
 ** module id = 147
 ** module chunks = 0
 **/